import {
  PieChartOutlined,
  FundOutlined,
  HomeOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import { useLocation } from "react-router-dom";
import { usePage } from "../../hooks/usePage";
import { RouteEnum } from "../../routes/routes";
import Logo from "../logo/Logo";

import styles from "./NavMenu.module.css";

export default function NavMenu() {
  const { pathname } = useLocation();
  const [, setPage] = usePage();

  return (
    <ul className={styles.menu}>
      <li className={styles.logo}>
        <button onClick={() => setPage(RouteEnum.DASHBOARD)}>
          <Logo height={32} />{" "}
          <span className={styles.logoText}>Money Workspace</span>
        </button>
      </li>
      <li data-active={pathname === RouteEnum.DASHBOARD}>
        <button onClick={() => setPage(RouteEnum.DASHBOARD)}>
          <PieChartOutlined className="icon" />
          <span className={styles.buttonText}>Dashboard</span>
        </button>
      </li>
      <li data-active={pathname === RouteEnum.WEALTH}>
        <button onClick={() => setPage(RouteEnum.WEALTH)}>
          <FundOutlined className="icon" />
          <span className={styles.buttonText}>Wealth</span>
        </button>
      </li>
      <li data-active={pathname === RouteEnum.HOUSE}>
        <button onClick={() => setPage(RouteEnum.HOUSE)}>
          <HomeOutlined className="icon" />
          <span className={styles.buttonText}>House</span>
        </button>
      </li>
      <li></li>
      <li data-active={pathname === RouteEnum.SETTINGS}>
        <button onClick={() => setPage(RouteEnum.SETTINGS)}>
          <SettingOutlined className="icon" />
          <span className={styles.buttonText}>Settings</span>
        </button>
      </li>
    </ul>
  );
}
